/**
 * DesktopIcon — ícone pixel-inspired. Single click abre janela, double click idem.
 * Selecionável (visual feedback), keyboard-activatable (Enter/Space).
 */
export default function DesktopIcon({ id, label, icon, tone = 'cyan', onOpen }) {
  const handleClick = () => onOpen?.(id);
  const handleKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onOpen?.(id);
    }
  };

  return (
    <button
      type="button"
      onPointerUp={(event) => {
        if (event.button === 0) handleClick();
      }}
      onDoubleClick={handleClick}
      onKeyDown={handleKey}
      className={`forge-desktop-icon forge-icon-${tone}`}
      aria-label={`Open ${label}`}
    >
      <span className="forge-desktop-icon-art">
        {icon}
      </span>
      <span className="forge-desktop-icon-label">
        {label}
      </span>
    </button>
  );
}
